import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

import crossCountryUtils from "~/utils/cross-country-utils";

type Props = {
  address: EVA.Core.AddressDto;
  fiscalId?: string;
};

export default function FormattedAddress({ address, fiscalId }: Props) {
  const t = useTranslations();
  const router = useRouter();

  if (!address) {
    return <></>;
  }

  return (
    <>
      {(address.FirstName || address.LastName) && (
        <p>
          {address.FirstName} {address.LastName}
        </p>
      )}
      <p>
        {address.Address1}
        {address.Address2 ? ` ${address.Address2}` : ""}
        {address.HouseNumber ? ", " + address.HouseNumber : ""}
        {address.District ? ", " + address.District : ""}
        {address.Subdistrict ? ", " + address.Subdistrict : ""}
        {address.City ? ", " + address.City : ""}
        {address?.CountryID ? ", " + crossCountryUtils.getLocalizedCountryName(address?.CountryID, router) : ""}
      </p>
      {fiscalId && (
        <>
          <br />

          <p>{t("generic.order.fiscalId", { value: fiscalId })}</p>
        </>
      )}
      {(address.EmailAddress || address.PhoneNumber) && (
        <>
          <br />
          {address.EmailAddress && <p>{address.EmailAddress}</p>}
          {address.PhoneNumber && <p>{address.PhoneNumber}</p>}
        </>
      )}
    </>
  );
}
